export enum SplitterCombinerType {

    ECONOMIZER = "economizer",
    SHARED = "shared",
    STAGED = "staged",
    TEMPERATURE = "temperature",
    COMBINER = "combiner"
}